/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

/* eslint-disable no-duplicate-imports */
import { INavigationMenuViewProps } from '@msdyn365-commerce-modules/navigation-menu';
import * as React from 'react';

import { IEveNavigationMenuProps } from '../definition-extensions/eve-navigation-menu.ext.props.autogenerated';
import NavigationMenuRootDisabled from './components/eve-navigation-menu-root-disabled';

/**
 * Render the Navigation menu.
 * @param props - The navigation menu view props.
 * @returns Return HTML having INavigationMenuViewProps props with navigation menu.
 */
const navigationMenuView = (props: INavigationMenuViewProps & IEveNavigationMenuProps<{}>): JSX.Element => {
    return <NavigationMenuRootDisabled navProps={props} />;
};

export default navigationMenuView;
